import { FormGroupClassKey } from '@material-ui/core/FormGroup';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDFormGroupStyles: Partial<
  Record<FormGroupClassKey, CSSProperties>
> = {};
